export function extractErrorMessage(error, fallBack = "") {
  return (
    error.response?.data?.message ||
    error?.body?.message ||
    fallBack ||
    error.response?._data?.message ||
    error.message
  );
}
